<template>
  <van-nav-bar :left-arrow="leftarrow" @click-left="lroute" :title="title" :fixed="true" class="main-header">
  </van-nav-bar>
</template>

<script>
  export default {
    data() {
      return {
        title: this.$store.state.tabTitle
      }
    },
    props:{
      leftarrow:{
        type:Boolean,
        default:false
      },
      lroute:{
        default:function(){
          return true
        }
      }
    }
  }
</script>

<style>
.van-nav-bar .van-icon{
  color: #DD403B;
}
</style>